import { ArrayElement } from "../utilities/ArrayElement";

export const suggestionBannerNames = Object.freeze([
  "Grow your community",
] as const);

export type VisibleSuggestionBanners = Partial<
  Record<ArrayElement<typeof suggestionBannerNames>, boolean>
>;
